export default "__VITE_ASSET__a920c35b__"